import { ROUTES } from "../../../routes";
import { Mode } from "../Todos.types";

export function getBasePathByMode(mode: Mode) {
  switch (mode) {
    case Mode.Onboarding:
      return ROUTES.onboarding.entry;
    case Mode.Universal:
      return ROUTES.universalTodos;
    default:
      return ROUTES.todos.entry;
  }
}
